export default {"src":"/_next/static/media/bg_yellow.a99ecece.svg","height":605,"width":2200,"blurWidth":0,"blurHeight":0};